import React from 'react';
import BreakdownRingChart from '../../../../../../shared/designSystem/components/BreakdownRingChart';

// CreativeRingChart is now a thin alias for the shared BreakdownRingChart.
// Keeps the legacy call-site shape (`selectedCreativeDimension` prop name)
// while centralizing the rendering logic, top-N aggregation, and tooltip in
// one place. Prefer importing BreakdownRingChart directly in new code.
const CreativeRingChart = ({ data, height, selectedCreativeDimension }) => (
  <BreakdownRingChart
    data={data}
    dimension={selectedCreativeDimension}
    height={height}
  />
);

export default CreativeRingChart;
